<template>
  <div v-if="paginatedOrganization">
    <h1 class="font-bold text-4xl text-on-background">
      {{ $t('organization.title') }}
    </h1>

    <EmptyList v-if="paginatedOrganization.nodes.length === 0" class="mt-30" />
    <div
      v-else
      class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 mt-10"
    >
      <div
        v-for="organization in paginatedOrganization.nodes"
        :key="organization.id"
        class="bg-surface rounded-xl aspect-[3/4]"
      >
        <div class="aspect-square w-full flex items-center justify-center">
          <NuxtLink :to="`/org/${organization.slug}`" class="w-10/12">
            <img
              :src="organization.logoUrl"
              :alt="$t('hub.alt')"
              class="aspect-square w-full object-cover"
            />
          </NuxtLink>
        </div>

        <div class="px-5">
          <hr />

          <NuxtLink
            :to="`/org/${organization.slug}`"
            class="truncate mt-4 block text-xl font-semibold text-on-surface"
          >
            {{ organization.name }}
          </NuxtLink>
          <div class="text-sm font-semibold text-on-surface-variant">
            {{ $t('common.hubs') }}
          </div>
          <div class="text-sm font-semibold text-on-surface-variant">
            {{ organization.contentsCount }} {{ $t('common.content-items') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { EmptyList } from '~/pages/_components/empty-list';
import { apiGetOrganizationList } from '~/api/organizations';
import { useAsyncData } from '#app';
import { handleApiError } from '~/api';

const { data: paginatedOrganization, error: hubsError } = useAsyncData(
  'organizations',
  () => {
    return apiGetOrganizationList({ perPage: 100, hasAccount: true });
  },
);

if (hubsError.value) {
  await handleApiError(hubsError.value);
}
</script>
